
import RequestRegisterBrandList from "@/views/RequestRegisterBrand/RequestRegisterBrandList";
import RequestRegisterBrandEdit from "@/views/RequestRegisterBrand/RequestRegisterBrandEdit";
import RequestRegisterProductList from "@/views/RequestRegisterProduct/RequestRegisterProductList";
import RequestRegisterProductEdit from "@/views/RequestRegisterProduct/RequestRegisterProductEdit";


const routes = [
 {
    path: '/RequestRegisterProduct/List',
    name: 'RequestRegisterProductList',
    component: RequestRegisterProductList,
    meta:{requiredAuth:true}
  },
 {
    path: '/RequestRegisterProduct/Edit/:id',
    name: 'RequestRegisterProductEdit',
    component: RequestRegisterProductEdit,
    meta:{requiredAuth:true}
  },
]

export default routes